import React from "react";
import { StyleSheet, Text, View } from "react-native";

import UserAvatar from "@/Components/Media/User/Images/UserAvatar";
import type { UserImageMedia } from "@/schemas/user/image";

interface AccountAvatarProps {
  color: string;
  size: number;
  avatar: UserImageMedia | null;
  unreadNotificationsCount: number;
}

function AccountAvatar({
  color,
  size,
  avatar,
  unreadNotificationsCount = 0,
}: AccountAvatarProps): React.JSX.Element {
  const hasUnread = unreadNotificationsCount > 0;

  return (
    <View style={styles.container} testID="account-avatar-icon">
      <UserAvatar avatar={avatar} defaultAvatarColor={color} size={size} />
      {hasUnread && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>
            {unreadNotificationsCount > 9 ? "9+" : unreadNotificationsCount}
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
  },
  badge: {
    position: "absolute",
    top: -5,
    right: -10,
    backgroundColor: "#FF3B30",
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 4,
  },
  badgeText: {
    color: "white",
    fontSize: 12,
    fontWeight: "bold",
  },
});

export default AccountAvatar;
